import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { Row, Col, Switch, Tooltip } from 'antd';
import styles from '../css/Header.module.css';
import { Menu } from './Menu';
import { getMenuItemId } from "../helpers/authorizationHelper";
import { storedLoginUserInfo } from '../../../modules/core/authModule';
import { isPrimeMenu, setCurrnetMenuItemId } from '../../../modules/core/menuModule';
import { initCriteria as initCriteriaAttendancePrime } from '../../../modules/prime/attendance/attendanceModule'
import { initCriteria as initCriteriaAttendancePartner } from '../../../modules/partner/attendance/attendanceModule'
import * as CONSTANTS from '../../../constants/constants';
import { initMessages } from '../../../modules/core/commonMessageModule';
import { QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";


export const Header = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const loginUserInfo = useSelector(storedLoginUserInfo);
  const isPrime = useSelector(isPrimeMenu);

  // トグル切替押下時、所定画面への遷移処理を行います。
  const switchOnChange = (checked: boolean) => {

    let path = "";
    if (checked) {
      // 利用不可の場合、処理を中断します。
      if ("0" === loginUserInfo.primeServiceAvailableFlg) {
        return;
      }
      // 元請_勤怠一覧に遷移します。
      path = CONSTANTS.PATH_PRIME_ATTENDANCE_SUMMARY;
    } else {
      if (window.innerWidth <= 850) {
        // 画面幅が850px以下のとき協力会社_勤怠一覧(スマホ用)に遷移します。
        path = CONSTANTS.PATH_PARTNER_ATTENDANCE_MOBILE_SUMMARY;
      } else {
        // 協力会社_勤怠一覧に遷移します。
        path = CONSTANTS.PATH_PARTNER_ATTENDANCE_SUMMARY;
      }
    }

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // 遷移先勤怠画面のCriteriaを初期化する
    dispatch(initCriteriaAttendancePrime());
    dispatch(initCriteriaAttendancePartner());

    // 機能をまたく遷移の場合、カレントメニューアイテムを書き換えます。
    dispatch(setCurrnetMenuItemId(getMenuItemId(path)));
    history.push(path);
  }

  // 本部・支店担当者ツールチップを作成する
  let corpAuthority = "閲覧権限";
  // 「利用者」「勤怠承認者」権限を保持している場合
  if (loginUserInfo.authorityInfo.primeAvailableAuth === '1' && loginUserInfo.authorityInfo.primeAttendanceApprovalAuth === '1') {
    corpAuthority = "承認権限";
  }
  let corporateTextList: Array<any> = [];
  corporateTextList.push(<div>【ユーザ情報】</div>);
  corporateTextList.push(<div>立場：本部・支店担当者</div>);
  corporateTextList.push(<div>権限：{corpAuthority}</div>)

  // 管理担当者ツールチップを作成する
  let managementTextList: Array<any> = [];
  managementTextList.push(<div>【ユーザ情報】</div>);
  managementTextList.push(<div>立場：管理担当者</div>);
  managementTextList.push(<div>権限：承認権限・管理者権限</div>);

  // 現場担当者ツールチップを作成する
  let onsiteAuthority = "確認権限"
  let onsiteComment;
  // 役割別権限で「承認権限」を保持している場合（承認権限を保持している場合、確認権限も保持している）
  if (loginUserInfo.authorityInfo.primeAttendanceReffenceRoleAuth === '1' && loginUserInfo.authorityInfo.primeAttendanceApprovalRoleAuth === '1') {
    onsiteAuthority = "承認権限・確認権限";
    onsiteComment = "※ご利用のプロジェクトによって、適用される権限が異なる場合がございます。" 
  }
  let onSiteTextList: Array<any> = [];
  onSiteTextList.push(<div>【ユーザ情報】</div>);
  onSiteTextList.push(<div>立場：現場担当者</div>);
  onSiteTextList.push(<div>権限：{onsiteAuthority}</div>);
  // 役割別権限で「確認権限」と「承認権限」を保持している場合は現場担当者ツールチップにコメントを追加
  if (onsiteComment) {
    onSiteTextList.push(<div>{onsiteComment}</div>);
  }

  // 協力・管理担当者ツールチップを作成する
  let partnerManagementTextList: Array<any> = [];
  partnerManagementTextList.push(<div>【ユーザ情報】</div>);
  partnerManagementTextList.push(<div>立場：管理担当者</div>);
  partnerManagementTextList.push(<div>権限：編集権限・提出権限・管理者権限</div>);
  partnerManagementTextList.push(<div>※元請会社の設定により、権限が制御される場合がございます。</div>);

  return (
    <div className={styles.HeaderFixed}>
      <Row className={styles.HeaderArea}>
        <Col span={6} className={styles.HeaderlogoArea}>
          <img
            className={styles.LogoStyle}
            src={isPrime ? CONSTANTS.PRIME_HEADER_ROGO : CONSTANTS.PARTNER_HEADER_ROGO}
            alt="スキルマップサイト" />
        </Col>
        <Col span={14} offset={4} className={styles.HeaderInfoArea}>
          <div>
            {// 本部・支店担当者（管理者権限がある場合は、表示しない）
              loginUserInfo.authorityInfo.primeAvailableAuth === '1' 
              && loginUserInfo.authorityInfo.primeSystemMngAuth === '0' 
              && window.location.pathname.includes("prime/") ? 
              <span className={styles.permissionArea}>
                本部・支店担当者
                <Tooltip
                  overlayStyle={{ maxWidth: '1000px' }}
                  placement="topRight" title={corporateTextList}>
                  <span>&nbsp;
                    <QuestionCircleFilled
                      style={{
                        fontSize: '14px',
                        borderRadius: '50%',
                        marginLeft: '3px'
                      }}
                    />&nbsp;
                  </span>
                </Tooltip>
              </span>
              : <></>
            }
            {// 管理担当者
              loginUserInfo.authorityInfo.primeSystemMngAuth === '1' && window.location.pathname.includes("prime/") ? 
              <span className={styles.permissionArea}>
                管理担当者
                <Tooltip
                  overlayStyle={{ maxWidth: '1000px' }}
                  placement="topRight" title={managementTextList}>
                  <span>&nbsp;
                    <QuestionCircleFilled
                      style={{
                        fontSize: '14px',
                        borderRadius: '50%',
                        marginLeft: '3px'
                      }}
                    />&nbsp;
                  </span>
                </Tooltip>
              </span>
              : <></>
            }
            {// 現場担当者
              window.location.pathname.includes("prime/")
              && (loginUserInfo.authorityInfo.primeAttendanceApprovalRoleAuth === '1' 
              || loginUserInfo.authorityInfo.primeAttendanceReffenceRoleAuth === '1') ? 
              <span className={styles.permissionArea}>
                現場担当者
                <Tooltip
                  overlayStyle={{ maxWidth: '320px' }}
                  placement="topRight" title={onSiteTextList}>
                  <span>&nbsp;
                    <QuestionCircleFilled
                      style={{
                        fontSize: '14px',
                        borderRadius: '50%',
                        marginLeft: '3px'
                      }}
                    />&nbsp;
                  </span>
                </Tooltip>
              </span>
              : <></>
            }
            {// 協力・編集権限（「協力利用者」権限のみ保持している場合）かつ、画面幅が850pxより大きい場合（PCの場合）
              window.innerWidth > 850 
              && window.location.pathname.includes("partner/")
              && !window.location.pathname.includes("prime/")
              && loginUserInfo.authorityInfo.partnerAvailableAuth === '1' 
              && loginUserInfo.authorityInfo.partnerAttendanceSubmitAuth === '0' 
              && loginUserInfo.authorityInfo.partnerSystemMngAuth === '0' ?
              <span className={styles.partnerPermissionArea}>
                編集権限あり
              </span>
              : <></>
            }
            {// 協力・提出権限（「協力利用者」「勤怠提出者」権限のみ保持している場合）かつ、画面幅が850pxより大きい場合（PCの場合）
              window.innerWidth > 850 
              && window.location.pathname.includes("partner/") 
              && !window.location.pathname.includes("prime/")
              && loginUserInfo.authorityInfo.partnerAvailableAuth === '1' 
              && loginUserInfo.authorityInfo.partnerAttendanceSubmitAuth === '1' 
              && loginUserInfo.authorityInfo.partnerSystemMngAuth === '0' ?
              <span className={styles.partnerPermissionArea}>
                提出権限あり
              </span>
              : <></>
            }
            {// 協力・管理担当者（管理者権限を保持している場合、つまりは協力側の全権限を保持）かつ、画面幅が850pxより大きい場合（PCの場合）
              window.innerWidth > 850 
              && window.location.pathname.includes("partner/") 
              && !window.location.pathname.includes("prime/")
              && loginUserInfo.authorityInfo.partnerSystemMngAuth === '1' ?
              <span className={styles.partnerManagementArea}>
                管理担当者
                <Tooltip
                  overlayStyle={{ maxWidth: '300px' }}
                  placement="topRight" title={partnerManagementTextList}>
                  <span>&nbsp;
                    <QuestionCircleFilled
                      style={{
                        fontSize: '14px',
                        borderRadius: '50%',
                        marginLeft: '3px'
                      }}
                    />&nbsp;
                  </span>
                </Tooltip>
              </span>
              : <></>
            }
            <Switch
              checkedChildren="元請会社"
              unCheckedChildren="協力会社"
              checked={isPrime}
              onChange={(checked) => switchOnChange(checked)}
              className="headerToggle"
            />
            <div>
              <span className={styles.noWrap}>{loginUserInfo.belongCompanyName}</span>
              <span className={styles.noWrap}>{loginUserInfo.belongBranchName}</span>
              <span className={styles.noWrap}>{loginUserInfo.name ? loginUserInfo.name + " 様" : loginUserInfo.name}</span>
            </div>
          </div>
        </Col>
      </Row>

      <Menu />
    </div>
  );
}
